import Vue from 'vue';
import App from './App.vue';
import methods from './methods';
import router from './router';
import store from './store';
import api from './api';

import { Alert, Confirm, Toast, Loading } from 'wc-messagebox';
import 'wc-messagebox/style.css';

import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';

import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';

Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Toast);
Vue.use(Loading);

Vue.use(preview);

Vue.use(VueVideoPlayer, {});

Vue.config.productionTip = false;
Vue.mixin({
	methods
});
Vue.use(api, {
	domain: process.env.VUE_APP_API_DOMAIN,
	handles: {
		success: (res: any) => {
			if (res.code == 0) {
				return res.data;
			}
			throw new Error(res.message);
		}
	}
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
